import { MarketSettingAPI } from "../api"

export class MarketSetting {
  constructor(props) {
    for (const [key, value] of Object.entries(props)) {
      this[key] = value;
    }
  }
  static async createMarketSetting(formData){
    const { data } = await MarketSettingAPI.createMarketSetting(formData);
    return new MarketSetting(data.result)
  }
  static async updateMarketSetting(formData){
    const { data } = await MarketSettingAPI.updateMarketSetting(formData);
    return new MarketSetting(data.result)
  }
}